import axios from 'axios'
import globalAxios from 'axios'
import router from './../../../router'

const namespaced = true;

const state = {
  account: {
    company: null,
    paymentMethodName: null,
    balance: 0.00,
    status: null,
  },
  cards: [],
  transactions: [],
};

const getters = {

  getAccount (state) {
    return state.account
  },

  getCompany (state) {
    return state.account.company
  },
  //
  // getBalance (state) {
  //   return state.account.balance
  // },
  //
  // getPaymentMethodName (state) {
  //   return state.account.paymentMethodName
  // },
  //
  // getCards (state) {
  //   return state.cards
  // },


  // getStatus (state) {
  //   if(state.account.status === 0){return 'Inactive'}
  //   if(state.account.status === 1){return 'Active'}
  //   if(state.account.status === 2){return 'Deactivated'}
  //   return null;
  // },
  //
  // getTransactions (state) {
  //   return state.transactions
  // }
};

const mutations = {
  setAccount (state, payload) {
    state.account = payload
  },

  // setCards (state, payload) {
  //   state.cards = payload
  // },
  //
  // setTransactions(state, payload){
  //   state.transactions = payload
  // }
};


const actions = {
  // sampleAction1 ({commit}, samplePayload) {
  //   commit('sampleMutation', samplePayload);
  // },

  fetchAccount ({commit, dispatch}, accountID) {
    return new Promise((resolve, reject) => {
      axios.get('/api/accounts/account/' + accountID)
        .then(res => {
          commit('setAccount', res.data.data)
          console.log('fetchAccount - Account details fetched.');
          resolve(res.data.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },


  // updateCompanyName ({commit, dispatch}, formPayload) {
  //   return new Promise((resolve, reject) => {
  //     axios.put('/api/accounts/account/'+formPayload.accounts_id, {
  //       company: formPayload.company,
  //       payment_methods_id: formPayload.payment_methods_id,
  //     })
  //       .then(res => {
  //         commit('setCompany', {
  //           company: res.data.data.company,
  //         })
  //         console.log('updateCompanyName - Company Name Updated.');
  //         resolve(res.data);
  //       })
  //       .catch(error => {
  //         reject(error.response);
  //       })
  //   })
  // },
  //
  // fetchCards ({commit, dispatch}) {
  //   return new Promise((resolve, reject) => {
  //     axios.get('/api/accounts/billing')
  //       .then(res => {
  //         commit('setCards', res.data.data)
  //         console.log('fetchCards - Card details fetched.');
  //         resolve(res.data.data);
  //       })
  //       .catch(error => {
  //         reject(error.response);
  //       })
  //   })
  // },
  //
  // storeCard ({commit, dispatch}, formData) {
  //   return new Promise((resolve, reject) => {
  //     axios.post('/api/accounts/billing', {
  //       name: formData.name,
  //       email: formData.email,
  //       telephone: formData.telephone,
  //       address1: formData.address1,
  //       address2: formData.address2,
  //       city: formData.city,
  //       postcode: formData.postcode,
  //       country: formData.country,
  //       cardNumber: formData.cardNumber,
  //       expDate: formData.expDate,
  //       CVC: formData.CVC,
  //     })
  //       .then(res => {
  //         resolve(res.data);
  //       })
  //       .catch(error => {
  //         // alert(JSON.stringify(formData))
  //         reject(error.response);
  //       })
  //   })
  // },
  //
  // makeDefaultCard ({commit, dispatch}, cardID) {
  //   return new Promise((resolve, reject) => {
  //     axios.get('/api/accounts/billing/default?billingID=' + cardID)
  //       .then(res => {
  //         resolve(res.data);
  //       })
  //       .catch(error => {
  //         reject(error.response);
  //       })
  //   })
  // },
  //
  //
  // updateSubscription ({commit, dispatch}, apiParamters) {
  //   return new Promise((resolve, reject) => {
  //     // alert(packageID + ' - ' + periodID + ' - ' + bundleIDs + ' - ' + total)
  //     axios.post('/api/accounts/subscription', {
  //       packageID: apiParamters.packageID,
  //       periodID: apiParamters.periodID,
  //       bundlesID: apiParamters.bundlesID,
  //       total: apiParamters.total,
  //     })
  //       .then(res => {
  //         resolve(res.data);
  //       })
  //       .catch(error => {
  //         reject(error.response);
  //       })
  //   })
  // },
  //
  //
  // fetchTransactions ({commit, dispatch}) {
  //   return new Promise((resolve, reject) => {
  //     axios.get('/api/accounts/account/transactions')
  //       .then(res => {
  //         commit('setTransactions', res.data.data)
  //         console.log('fetchTransactions - Transaction details fetched.');
  //         resolve(res.data.data);
  //       })
  //       .catch(error => {
  //         reject(error.response);
  //       })
  //   })
  // },

};


export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/security/account.js